<template>
    <div id="content">
      <div class="inner_static">
        <h1 id="logo" class="kagull_logo_h1">
          <strong>カグル.</strong>
        </h1>
        <div id="bx_login">
          <h2 id="tit_login">ログイン</h2>
            <fieldset class="login_form">
              <div class="error_message">{{ errorMessage.text }}</div>
              <legend class="blind">ログイン</legend>
              <div class="id_area">
                <input type="text" v-model="form.loginId" id="id" name="id" class="int">
                <div class="error_message">{{ fieldErrorMessages.loginId }}</div>
              </div>
              <div class="pw_area">
                <input type="password" v-model="form.password" id="pw" name="pw" class="int" maxlength="12">
                <div class="error_message">{{ fieldErrorMessages.password }}</div>
              </div>
              <div class="find_area">
                <a class="find_info" @click="passwordReset()">パスワードを忘れた方</a>
              </div>
              <div class="btn_area">
                <button class="input_style_submit btn1" @click="login()">ログインする</button>
              </div>
            </fieldset>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import {KG_URL, KG_STORAGE_KEY} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'

export default {
  name: 'Login',
  data () {
    return {
      form: {
        loginId: '',
        password: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      }
    }
  },
  methods: {
    login: function (event) {
      let payload = {
        loginId: this.form.loginId,
        password: this.form.password
      }
      this.clearMessages()
      axios.post(KG_URL.USER, payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.errorMessage.text = response.data.errorMessage
          } else {
            // 旧データ削除
            App.removeLocalStorage(KG_STORAGE_KEY.USER_INFO)
            App.removeLocalStorage(KG_STORAGE_KEY.PASSWORD_DATA)
            App.removeLocalStorage(KG_STORAGE_KEY.SELECT_CATEGORY_DATA)
            App.removeLocalStorage(KG_STORAGE_KEY.SELECT_STYLE_DATA)
            App.removeLocalStorage(KG_STORAGE_KEY.SELECT_PLAN_DATA)
            App.removeLocalStorage(KG_STORAGE_KEY.SIZE_DATA)
            App.removeLocalStorage(KG_STORAGE_KEY.CONTACT_DATA)
            App.removeLocalStorage(KG_STORAGE_KEY.SELECT_NEWS_DATA)
            // ログイン成功時ローカルストレージにユーザー情報を格納※セキュリティ上問題ないもののみ
            let data = response.data.data
            let userInfo = {
              userId: data.userId,
              corpId: data.corpId,
              corpName: data.corpName,
              userLastName: data.userLastName,
              userFirstName: data.userFirstName,
              userLastNameKana: data.userLastNameKana,
              userFirstNameKana: data.userFirstNameKana,
              userNickName: data.userNickName,
              userType: data.userType,
              postcd: data.postcd,
              state: data.state,
              city: data.city,
              street: data.street,
              tel: data.tel,
              userStatus: data.userStatus,
              isAccountPay: data.isAccountPay,
              userDebugFlg: data.userDebugFlg
            }
            App.setLocalStorage(KG_STORAGE_KEY.USER_INFO, userInfo)
            if (userInfo.userStatus === 'REGISTERED') {
              this.$router.push('/kagull/top')
            } else if (userInfo.userStatus === 'NEW') {
              // TODO カグルは登録時にパスワードの設定をするためここは不要?
              // this.$router.push('/mmstyle/password')
            }
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        loginId: '',
        password: ''
      }
    },
    newUser: function () {
      // TODO: カグルのトップのデザインに新規登録リンクが見当たらない
      // this.$router.push('/mmstyle/user/mail')
    },
    passwordReset: function () {
      // パスワードリセットトップ画面への遷移
      this.$router.push('/kagull/user/reset/top')
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/login/LoginForm.vue